import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';
import SrFormikField, {
  SR_FIELD_THEME_PARTNER_FORM,
  SR_FIELD_THEME_LONG_TEXTAREA,
} from 'client/components/SrFormikField';
import SrModalContent from 'client/components/SrModalContent';
import SrDarkModal from 'client/components/SrDarkModal';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

const formFields = [
  {
    id: 'notes',
    title: 'notes for the sunroom team',
    label: '(optional)',
    type: 'long_text',
    properties: {
      placeholder: 'Write here...',
    },
  },
];

const SrMarketingPartnerMarkAsResolvedModal = ({ onSubmit, onClose }) => (
  <div className='SrMarketingPartnerMarkAsResolvedModal'>
    <Formik
      enableReinitialize
      initialValues={createInitialValues({ formFields })}
      validate={createFormValidationFn(formFields)}
      onSubmit={onSubmit}
      render={(formikBag) => {
        return (
          <SrDarkModal
            className='SrMarketingPartnerMarkAsResolvedModal'
            onClose={onClose}
          >
            <Form>
              <SrModalContent>
                <div className='container'>
                  <div className='header'>
                    <span
                      size='2xl'
                      weight='bold'
                      leading='35'
                      className='title'
                    >
                      Write a ‘Resolved Note’
                    </span>
                    <span
                      size='2xl'
                      weight='light'
                      leading='35'
                      className='subtitle'
                    >
                      What would you like us to know about how it was resolved?
                    </span>
                  </div>
                  <div className='content'>
                    <SrBox paddingTop='5'>
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={`${SR_FIELD_THEME_PARTNER_FORM} ${SR_FIELD_THEME_LONG_TEXTAREA}`}
                        />
                      ))}
                    </SrBox>
                  </div>
                  <div className='footer'>
                    <SrFlex justify='between'>
                      <SrText className='cancelButton' onClick={onClose}>
                        Cancel
                      </SrText>
                      <ButtonDeprecated className='submitButton' theme={BUTTON_THEME_YELLOW} type='submit'>
                        send
                      </ButtonDeprecated>
                    </SrFlex>
                  </div>
                </div>
              </SrModalContent>
            </Form>
          </SrDarkModal>
        );
      }}
    />
  </div>
);

SrMarketingPartnerMarkAsResolvedModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrMarketingPartnerMarkAsResolvedModal.displayName = 'SrMarketingPartnerMarkAsResolvedModal';

export default SrMarketingPartnerMarkAsResolvedModal;
